/* 🤖 this file was generated by svg-to-ts */
export const siriusImage: {
  name: 'image';
  data: string;
} = {
  name: 'image',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path d="M15.75 9.375a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M2.25 5.25a1.5 1.5 0 0 1 1.5-1.5h16.5a1.5 1.5 0 0 1 1.5 1.5v13.5a1.5 1.5 0 0 1-1.5 1.5H3.75a1.5 1.5 0 0 1-1.5-1.5V5.25Zm18 0v10.19l-2.681-2.682-.003-.002a1.498 1.498 0 0 0-2.132 0l-1.93 1.93-.004.003-4.184-4.183a1.5 1.5 0 0 0-2.132 0L3.75 13.939V5.25h16.5ZM8.246 11.565 3.75 16.06v2.689h16.5v-1.19l-3.75-3.75-.004.005-1.93 1.93a1.5 1.5 0 0 1-2.132 0L8.25 11.56l-.004.004Z" fill="currentColor"/></svg>`
};
